import React, { useState, useEffect } from "react";
import { Input, Modal } from "antd";
import { Application } from "../../utils/storage";
import Note from "../Note";

function HomePage() {
  const [isOpen, setIsOpen] = useState(true);
  const [codeStatus, setCodeStatus] = useState();

  /**
   * open modal with password
   */
  const handleOk = (val) => {
    if (val === "jenote") {
      setIsOpen(false);
      setCodeStatus("warning");
      Application.set("user", "je");
      return;
    }
    setCodeStatus("error");
  };

  return (
    <div className="home-container">
      {Application.get("user") === "je" && <Note />}

      {isOpen && Application.get("user") !== "je" && (
        <Modal
          title="Enter user code"
          open={isOpen}
          centered={true}
          maskClosable={false}
          footer={null}
        >
          <Input
            style={{ margin: "10px 0 30px" }}
            status={codeStatus}
            onChange={(e) => handleOk(e.target.value)}
          />
        </Modal>
      )}
    </div>
  );
}

export default HomePage;
